import Utils from "../../common/Utils";
import AppVariables from "../../common/AppVariables";
import {Gender} from "../../common/Constants";
import {getCrops} from "../../data/crops";
import {ComparisonOperators, ComparisonSelect} from "../../components/CRUDView/Components/ComparisonSelect";
import {CustomFilterFrame} from "../../components/CRUDView";
import {ButtonGroup, FormGroup, InputGroup, InputGroupAddon, Row} from "reactstrap";
import Col from "reactstrap/es/Col";
import ClearButton from "../../components/CRUDView/Components/ClearButton";
import {Async as AsyncSelect, components} from "react-select";
import TwoLineItemRender from "../../components/Elements/TwoLineItemRender";
import {FBOEndpoints} from "../../common/ProxyEndpoints";
import Button from "reactstrap/es/Button";
import _ from "lodash";
import React from "react";
import TTLProxy from "../../common/TTLAsyncProxy";
import DialogCollapseSection from "../../components/DialogCollapseSection";
import {getActiveQuantityInfo, getQuantityKey} from "../../common/QuantityHelper";


export const FARMERS_QUERY_FILTERS = [
    {
        key: 'sex',
        query: "gender",
        name: "Gender",
        apply: true,
        fromQuery: value => {

            if(isFinite(value))
                return Number(value);

            if(value){
                switch (value.toLowerCase()) {
                    case "male":
                        return Gender.Male;
                    case "female":
                        return  Gender.Female;
                }
            }

        },
        renderValue: value => {

            switch (value) {
                case Gender.Male:
                    return "Male";
                case Gender.Female:
                    return  "Female";
            }
        }
    },
    {
        key: 'phone',
        operator: '[]',
        query: 'phone',
        apply: true // indicates this filter should be applied to real query
    },
    {
        key: 'name',
        operator: '[]',
        query: 'name',
        apply: true // indicates this filter should be applied to real query
    },
    {
        key: 'fbo.id',
        query: 'fbo_id',
        apply: true
    },
    {
        key: 'fboName',
        query: '_fbo_select_name',
    },
    {
        key: 'farmLocation',
        operator: '[]',
        query: 'farm_location',
        apply: true // indicates this filter should be applied to real query
    },
    {
        key: 'farmSize',
        filterKey:  getQuantityKey({ acre: 'acres' , hectare: 'hectares' }),
        operator: filters => filters.farmSizeOperator || "=",
        query: 'farm_size',
        apply: true // indicates this filter should be applied to real query
    },
    {
        key: 'farmSizeOperator',
        query: 'farm_size_op',
        fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
    },

];

export const CustomFarmersFilter = ({ applyFilters, toggle , values , setValue , setValues , resetValues , includeFBO = true }) => {

    const proxy = TTLProxy.getInstance();

    return <CustomFilterFrame toggle={toggle}>

        <Row className="mb-1">

            <Col md={3}>

                <b>Name</b>
                <input name="name"
                       value={values['name']}
                       onChange={evt => {
                           setValue('name',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Farmer name"/>

            </Col>

            <Col md={3}>

                <b>Phone</b>
                <input name="phone"
                       value={values['phone']}
                       onChange={evt => {
                           setValue('phone',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Phone no."/>
            </Col>

            <Col md={3}>
                <b>Location</b>
                <input name="farmLocation"
                       value={values['farmLocation']}
                       onChange={evt => {
                           setValue('farmLocation',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Farm location"/>
            </Col>

            <Col md={3}>

                <b>Farm Size</b>
                <FormGroup>
                    <InputGroup>


                        <input name="farmSize"
                               value={values['farmSize']}
                               onChange={evt => {
                                   setValue('farmSize',evt.target.value);
                               }}
                               type="number"
                               className="form-control form-input-select"
                               placeholder="Farm size"/>

                        <InputGroupAddon addonType="prepend">
                            <ComparisonSelect value={values['farmSizeOperator']} onChange={operator => setValue('farmSizeOperator',operator)}/>
                        </InputGroupAddon>

                    </InputGroup>
                </FormGroup>


            </Col>

        </Row>

        {includeFBO && <Row>
            <Col md={3}>

                <div className="clearfix">
                    <b className="pull-left">FBO</b>
                    <div className="pull-right">
                        <ClearButton onClick={() => setValues({
                            fbo: null,
                            fboName: null
                        })}/>
                    </div>
                </div>
                <AsyncSelect  name="fbo"
                              defaultOptions
                              cacheOptions
                              placeholder="Select FBO..."
                              value={values['fbo']}
                              onChange={value => {
                                  setValue('fbo',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const fbo = props.data.instance;
                                      return <components.Option {...props}>

                                          <TwoLineItemRender  media={fbo.media}
                                                              line1Value={fbo.name}
                                                              line2Prefix="Phone"
                                                              line2Value={fbo.user.phone}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const res = await proxy.processRequest(FBOEndpoints.getUrl(), {
                                          search: { keyword: value , method: 'inside', fields: ['name','user.email', 'user.phone' ] },
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media' , 'user' ]
                                      });

                                      return res.getPayload().map(t => ({ label: t.name , value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                      // failed to load query

                                  }

                              }}/>


            </Col>
        </Row>}

        <hr/>

        <div className="clearfix">

            <div className="pull-left">
                <Button onClick={() => resetValues() }><i className="fa fa-refresh"/> Reset Filters</Button>
            </div>

            <div className="pull-right">
                <Button color="green" style={{ borderRadius: 4 }} onClick={() => {

                    let _targetFilter = { };
                    Object.keys(values).forEach(k => {

                        let _v = values[k];
                        let _initialValue = _v;

                        switch (k) {
                            case "fbo":
                                k = "fbo.id";
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['fboName'] = _v ? _initialValue.instance.name : undefined;
                                break;
                        }

                        if(!_.isNil(_v) && _v !== ""){
                            _targetFilter[k] = _v;
                        }
                        else{
                            _targetFilter[k] = undefined;
                        }

                    });

                    applyFilters(_targetFilter);


                }}><i className="fa fa-check"/> Apply</Button>
            </div>
        </div>


    </CustomFilterFrame>
};

export function parseFarmerQueryFilters(filters) {

    const getSelectOption = (entity,queryKey,filterKey) => {
        const _key = filterKey || `${entity}.id`;
        const _name = filters[queryKey || `${entity}Name`];
        return filters[_key] ? { label: _name , value: filters[_key]  , instance: { id : filters[_key] , name: _name } } : null ;
    };

    return {
        name: filters.name || '',
        phone: filters.phone || '',
        farmLocation: filters.farmLocation || '',
        fbo: getSelectOption('fbo'),
        farmSize: filters.farmSize || '',
        farmSizeOperator: filters.farmSizeOperator || "="
    };

}


class FarmersCommon{


    static getFarmerInputs(fbo, {   locationMode = 'custom' ,
                                    onLocationModeChange,
                                    provinces,
                                    districts ,
                                    wards ,
                                    onProvinceChanged ,
                                    onDistrictChanged }){

        let values =  [
            { name : 'name' , title: 'Name' , hint : `Enter farmer name here eg ${AppVariables.NameExample}` , type: 'text' , icon : 'fa fa-user' , required: true },
            { name : 'phone', title: 'Phone number' , hint : `Phone number eg ${AppVariables.PhoneNumberExample}` , type: 'phone' , icon : 'fa fa-phone' , required: true }
        ];

        values.push({
            group: [
                { name : 'sex'  , title: 'Gender' , hint: 'Select farmer gender' , type: 'select' , format: 'number' , icon : 'fa fa-user' , items: [
                        { value : Gender.Male , text: 'Male' },
                        { value : Gender.Female , text: 'Female' }
                    ],
                    container: content => <Col md={6}>{content}</Col>
                },
                {
                    name : 'date_of_birth' , title: 'Date Of Birth' , hint : 'Select date of birth', icon: 'fa fa-calendar' , format: value => (_.isNil(value) || value === "") ? null : value, type: 'datetime',
                    container: content => <Col md={6}>{content}</Col>
                }
            ],
            render: (content,i) => <Row key={i}>
                {content}
            </Row>
        });

        let locationInputs = [];

        switch (locationMode) {

            case 'custom':{

                locationInputs.push({ name : 'farm_location' , title: 'Location' , hint : 'Enter farm location here' , type: 'location' , icon : 'fa fa-map-marker' , coord: {
                        lat: 'farm_location_lat',
                        lng: 'farm_location_long'
                    }});

            }break;

            case 'select': {

                locationInputs = locationInputs.concat([
                    { name: 'province' , title: process.env.REACT_APP_LOCATION_COMP1, type: 'select' , items:  [{ text: `Select ${process.env.REACT_APP_LOCATION_COMP1.toLowerCase()}...`, value: '' , disabled: true , selected: true }].concat(provinces) , onChange: onProvinceChanged },
                    { name: 'district', title: process.env.REACT_APP_LOCATION_COMP2, type: 'select' , items: [{ text: `Select ${process.env.REACT_APP_LOCATION_COMP2.toLowerCase()}...`, value: '' , disabled: true , selected: true }].concat(districts), onChange: onDistrictChanged  , disabled: districts.length === 0 },
                    { name: 'ward' , title: process.env.REACT_APP_LOCATION_COMP3 , type: 'select' , items: [{ text: `Select ${process.env.REACT_APP_LOCATION_COMP3.toLowerCase()}...`, value: '' , disabled: true , selected: true }].concat(wards) , disabled: wards.length === 0 },
                ]);

            }break;

        }

        values.push({
            group: locationInputs,
            render: (content,k) => {

                return <CustomFilterFrame key={k}>

                    <div className="clearfix">

                        <div className="pull-left">
                            <h6>Farm Location</h6>
                        </div>

                        <div className="pull-right">

                            <ButtonGroup>
                                <Button style={{ zIndex: 'inherit' }} size={"sm"} active={locationMode === "select"} onClick={() => onLocationModeChange('select')}><i className="fa fa-map"/> Known Location</Button>
                                <Button style={{ zIndex: 'inherit' }} size={"sm"} active={locationMode === "custom"} onClick={() => onLocationModeChange('custom')}><i className="fa fa-map-marker"/> Custom</Button>
                            </ButtonGroup>

                        </div>

                    </div>

                    <hr/>

                    {content}

                </CustomFilterFrame>
            }

        });

        values = values.concat([
            { name : getQuantityKey({ acre: 'acres' , hectare: 'hectares' })  , title: `Farm Size (${getActiveQuantityInfo().plural})` , hint : `Enter farm size in ${getActiveQuantityInfo().plural.toLowerCase()} eg 24`, icon: 'fa fa-dot-circle-o' , type: 'number' ,format: value => value === "" ? null : Number(value) , setValue: (input,item) => input.value = getQuantityKey({ acre: item.acres , hectare: item.hectares }) || 0, min: 0 , defaultValue: 1 },
            { name: 'crop' , title: 'Crop' , simple: true , hint: "Select farmer's crop" , icon: 'fa fa-food' , type: 'dropdown' , items: getCrops().map(c => ({ value: c, text: c }) ) , multi: true }
        ]);


        if(fbo){

            values = values.concat({ name: 'fbo' , title: 'FBO (Farmer Based Organization)' , hint: 'Select FBO' , type: 'select' , format: 'number',
                items : () => Utils.insertNone(fbo.map((item) => { return { value: item.id , text: item.user.phone ? `${item.name} (${item.user.phone})` :  item.name } } ) ) ,
                setValue: (input,item) => input.value = item.fbo ? item.fbo.id : '',
            });

        }

        return values.concat({
            group: [
                { name : 'email' , title: 'Email' , hint : 'Enter email here', icon: 'fa fa-envelope' , type: 'email' , defaultValue: ''},
            ],
                render: (content,key) =>{
            return <DialogCollapseSection key={key} initiallyOpen={false} title={"Optional"}>
                {content}
            </DialogCollapseSection>
        }});

    }

}

export default FarmersCommon;



// WEBPACK FOOTER //
// ./src/views/Farmers/FarmersCommon.js